module.exports = __webpack_public_path__ + "static/header-eb43dfd96e6550b38b4fffa5384564a3.jpg";